module.exports = __webpack_public_path__ + "img/Portail bicoloration.84a14edd.jpg";